var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3f7ff;}.b{fill:#c1d4f8;}.c{fill:#9dbafc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-609 -186)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(609 186)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(629.835 227.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.123)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M127.837,0a17.046,17.046,0,1,0,17.046,17.046A17.091,17.091,0,0,0,127.837,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.165 34.658)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.041,260.243a15.956,15.956,0,0,0-1.69-3.126,20.882,20.882,0,0,0-14.472-9.23,3.065,3.065,0,0,0-2.13.521,17.744,17.744,0,0,1-21.158,0,2.729,2.729,0,0,0-2.13-.521,20.731,20.731,0,0,0-14.472,9.23,18.4,18.4,0,0,0-1.69,3.126,1.6,1.6,0,0,0,.073,1.414,29.722,29.722,0,0,0,1.984,2.978,28.174,28.174,0,0,0,3.379,3.871,44.208,44.208,0,0,0,3.379,2.977,33.151,33.151,0,0,0,39.965,0,32.427,32.427,0,0,0,3.379-2.977,34.233,34.233,0,0,0,3.379-3.871,26.118,26.118,0,0,0,1.984-2.978A1.283,1.283,0,0,0,82.041,260.243Z",
    transform: "translate(-24.165 -247.841)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleProfile);
export default __webpack_public_path__ + "static/media/sample-profile.eae1431c.svg";
export { ForwardRef as ReactComponent };